export enum MessageSetSortBy {
  dynamic = 'dynamic',
  messagesCount = 'messagesCount',
  public = 'public',
  title = 'title'
}

export enum MessageSetSortDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum MessageDisplayType {
  flagship = 'flagship',
  note = 'note'
}